import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import { typeface, get_color, respond } from '../assets/styles/index';
import { Tab, TabPane } from '../component/Tab';
import { PrimaryTitle } from '../component/PrimaryTitle';
import tab_01_en from '../assets/images/01_unrealised_pnl_EN.jpg';
import tab_01_tc from '../assets/images/01_unrealised_pnl_TC.jpg';
import tab_01_sc from '../assets/images/01_unrealised_pnl_SC.jpg';
import tab_02_en from '../assets/images/02_set_up_average_price_EN.jpg';
import tab_02_tc from '../assets/images/02_set_up_average_price_TC.jpg';
import tab_02_sc from '../assets/images/02_set_up_average_price_SC.jpg';
import tab_03_en from '../assets/images/03_update_average_price_EN.jpg';
import tab_03_tc from '../assets/images/03_update_average_price_TC.jpg';
import tab_03_sc from '../assets/images/03_update_average_price_SC.jpg';
import tab_04_en from '../assets/images/04_order_status_EN.jpg';
import tab_04_sc from '../assets/images/04_order_status_SC.jpg';
import tab_04_tc from '../assets/images/04_order_status_TC.jpg';
import tab_05_en from '../assets/images/05_1_quick_menu_EN.jpg';
import tab_05_tc from '../assets/images/05_1_quick_menu_TC.jpg';
import tab_05_sc from '../assets/images/05_1_quick_menu_SC.jpg';
import tab_05_2_en from '../assets/images/05_2_view_details_EN.jpg';
import tab_05_2_tc from '../assets/images/05_2_view_details_TC.jpg';
import tab_05_2_sc from '../assets/images/05_2_view_details_SC.jpg';

const Container = styled.div`
  margin-bottom: 64px;
`

const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  &:not(:first-child){
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid ${get_color('grey06')};
  }
  ${respond(['m','s'], `
    &:not(:first-child){
      padding-top: 16px;
      margin-top: 16px;
    }
  `)}
`

const TabContentImgBox = styled.img`
  width: 320px;
  height: 460px;
  margin-bottom: 24px;
  ${respond(['m','s'], `
    margin-bottom: 16px;
  `)}
  ${respond(['s'], `
    width: 258px;
    height: 372px;
  `)}
`

const TabContentText = styled.div`
  ${typeface('body2')}
  color: ${get_color('grey01')};
  text-align: left;
  max-width: 612px;
  width: 100%;
  .title{
    ${typeface('title6')}
    font-weight: 600;
    padding-bottom: 8px;
  }
  .subtitle{
    ${typeface('body1')} 
    :not(:first-of-type){
      padding-top: 8px;
    }
  }
  ${respond(['s'], `
    ${typeface('body4')}
    .title{
      ${typeface('title8')}
    }
    .subtitle{
      ${typeface('body3')} 
    }
  `)}

`

const HowToUse = () => {
  const { t, i18n } = useTranslation();
  return (
    <Container>
        <PrimaryTitle>{t('how_to_use.title')}</PrimaryTitle>
        <Tab defaultKey={'tab1'}>
        <TabPane title={t('how_to_use.tab_1.title')} key={'tab1'}>
            <TabContentContainer>
              <TabContentImgBox src={i18n.language === 'en-HK' ? tab_01_en : i18n.language === 'zh-HK' ? tab_01_tc : tab_01_sc} alt='' />
              <TabContentText>
                  {t('how_to_use.tab_1.content')}
              </TabContentText>
            </TabContentContainer>
        </TabPane>
        <TabPane title={t('how_to_use.tab_2.title')} key={'tab2'}>
            <TabContentContainer>
              <TabContentImgBox src={i18n.language === 'en-HK' ? tab_02_en : i18n.language === 'zh-HK' ? tab_02_tc : tab_02_sc} alt='' />
              <TabContentText>
                  {t('how_to_use.tab_2.content')}
              </TabContentText>
            </TabContentContainer>
        </TabPane>
        <TabPane title={t('how_to_use.tab_3.title')} key={'tab3'}>
            <TabContentContainer>
              <TabContentImgBox src={i18n.language === 'en-HK' ? tab_03_en : i18n.language === 'zh-HK' ? tab_03_tc : tab_03_sc} alt='' />
              <TabContentText>
                  {t('how_to_use.tab_3.content')}
              </TabContentText>
            </TabContentContainer>
        </TabPane>
        <TabPane title={t('how_to_use.tab_4.title')} key={'tab4'}>
            <TabContentContainer>
              <TabContentImgBox src={i18n.language === 'en-HK' ? tab_04_en : i18n.language === 'zh-HK' ? tab_04_tc : tab_04_sc} alt='' />
              <TabContentText>
                  {t('how_to_use.tab_4.content')}
              </TabContentText>
            </TabContentContainer>
        </TabPane>
        <TabPane title={t('how_to_use.tab_5.title')} key={'tab5'}>
            <TabContentContainer>
              <TabContentImgBox src={i18n.language === 'en-HK' ? tab_05_en : i18n.language === 'zh-HK' ? tab_05_tc : tab_05_sc} alt='' />
              <TabContentText>
                  <div role="heading" aria-level={4} className="title">{t('how_to_use.tab_5.content1_title')}</div>
                  {t('how_to_use.tab_5.content1')}
              </TabContentText>
              <TabContentContainer>
                <TabContentImgBox src={i18n.language === 'en-HK' ? tab_05_2_en : i18n.language === 'zh-HK' ? tab_05_2_tc : tab_05_2_sc} alt='' />
                <TabContentText>
                    <div role="heading" aria-level={4} className="title">{t('how_to_use.tab_5.content2_title')}</div>
                    <div role="heading" aria-level={5} className="subtitle">{t('how_to_use.tab_5.content2_subtitle_1')}</div>
                    {t('how_to_use.tab_5.content2_sub_1')}
                    <div role="heading" aria-level={5} className="subtitle">{t('how_to_use.tab_5.content2_subtitle_2')}</div>
                    {t('how_to_use.tab_5.content2_sub_2')}
                </TabContentText>
              </TabContentContainer>
            </TabContentContainer>
        </TabPane>
        </Tab>
    </Container>
  );
}

export default HowToUse;
